// @subframe/sync-disable

"use client";
/*
 * Documentation:
 * Dc_Text_Citation_Trigger_Unsynced — https://app.subframe.com/4f62853ee923/library?component=Dc_Text_Citation_Trigger_Unsynced_f2dc83d7-dd42-4eb3-b5d9-a2e5a347781f
 * Link Button — https://app.subframe.com/4f62853ee923/library?component=Link+Button_a4ee726a-774c-4091-8c49-55b659356024
 */

import React from "react";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";
import { LinkButton } from "./LinkButton";

interface SourceItemProps extends React.HTMLAttributes<HTMLDivElement> {
  reference?: React.ReactNode;
  linkSlot?: React.ReactNode;
  className?: string;
}

const SourceItem = React.forwardRef<HTMLDivElement, SourceItemProps>(
  function SourceItem(
    { reference, linkSlot, className, ...otherProps }: SourceItemProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex flex-col items-start gap-4",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        {reference ? (
          <span className="text-caption font-caption text-default-font">
            {reference}
          </span>
        ) : null}
        {linkSlot ? (
          <div className="flex flex-col items-start gap-4">{linkSlot}</div>
        ) : null}
      </div>
    );
  }
);

interface SourceItemLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const SourceItemLink = React.forwardRef<HTMLDivElement, SourceItemLinkProps>(
  function SourceItemLink(
    { children, className, ...otherProps }: SourceItemLinkProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex flex-col items-start gap-4",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        <LinkButton variant="brand" size="small">
          {children}
        </LinkButton>
      </div>
    );
  }
);

interface Dc_Text_Citation_Trigger_UnsyncedRootProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  type?: "default";
  citationIndex?: React.ReactNode;
  reference?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Dc_Text_Citation_Trigger_UnsyncedRoot = React.forwardRef<
  HTMLSpanElement,
  Dc_Text_Citation_Trigger_UnsyncedRootProps
>(function Dc_Text_Citation_Trigger_UnsyncedRoot(
  {
    type = "default",
    citationIndex,
    reference,
    children,
    className,
    ...otherProps
  }: Dc_Text_Citation_Trigger_UnsyncedRootProps,
  ref
) {
  return citationIndex ? (
    <SubframeCore.HoverCard.Root openDelay={100}>
      <SubframeCore.HoverCard.Trigger asChild={true}>
        <span
          className={SubframeUtils.twClassNames(
            "group/f2dc83d7 cursor-pointer text-body font-body text-compcolortextcitationtrigger p-[4px] m-[-4px] hover:text-compcolortextcitationtriggerhover",
            className
          )}
          ref={ref}
          {...otherProps}
        >
          {citationIndex}
        </span>
      </SubframeCore.HoverCard.Trigger>
      <SubframeCore.HoverCard.Portal>
        <SubframeCore.HoverCard.Content
          side="top"
          align="center"
          sideOffset={4}
          asChild={true}
        >
          {children ? (
            <div className="flex max-w-[448px] flex-col items-start gap-1 rounded-md border border-solid border-neutral-border bg-default-background px-3 py-3 shadow-lg">
              {children}
            </div>
          ) : null}
        </SubframeCore.HoverCard.Content>
      </SubframeCore.HoverCard.Portal>
    </SubframeCore.HoverCard.Root>
  ) : null;
});

export const Dc_Text_Citation_Trigger_Unsynced = Object.assign(
  Dc_Text_Citation_Trigger_UnsyncedRoot,
  {
    SourceItem,
    SourceItemLink,
  }
);
